import { render, staticRenderFns } from "./BaseInputToggle.vue?vue&type=template&id=509bb2f4&scoped=true&"
import script from "./BaseInputToggle.vue?vue&type=script&lang=js&"
export * from "./BaseInputToggle.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./BaseInputToggle.vue?vue&type=style&index=0&id=509bb2f4&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "509bb2f4",
  null
  ,true
)

export default component.exports